/**
 * Primeo - Gestion des écoles primaires
 *
 * SITel - Service de l'informatique et des télécommunications
 * ITA - Amt für Informatik und Telekommunikation
 * Impasse de la colline 1 Givisiez, CH-1701 Fribourg
 *
 * All rights reserved.
 */

'use strict';
/**
 * Convert a utc date to the format yyyy.MM.dd hh:mm:ss
 * this require moment.js !
 */
var core = angular.module('CoreUtils', []);

core.service('ObjectUtils', [function () {
    var self = this;
    /**
     * Read an object property by a path
     * by example:
     * readPath({address:{npa: 1630}}, 'address.npa') will return 1630
     * @param {Object} obj the object to read
     * @param {type} path the path to access
     * @returns {?} the object value
     */
    this.readPath = function (obj, path) {
        var ret = null;
        if (path && obj) {
            var crtObj = obj;
            var paths = path.split('\.');
            for (var i = 0; i < paths.length; i++) {
                var p = paths[i];
                crtObj = crtObj[p];
                if (!crtObj) {
                    break;
                }
            }
            if (crtObj) {
                ret = crtObj;
            }
        }
        return ret;
    };

    this.readPathSafe = function (obj, path, defaultValue) {
        var val = null;
        if (defaultValue !== undefined && defaultValue !== null) {
            val = defaultValue;
        }

        var pathComplete = false;

        // Read the path...
        if (path && obj) {
            var crtObj = obj;
            var paths = path.split('\.');
            for (var i = 0; i < paths.length; i++) {
                var p = paths[i];
                crtObj = crtObj[p];
                if (crtObj === undefined || crtObj === null) {
                    break;
                }
                if (i === paths.length - 1) {
                    pathComplete = true;
                }
            }
            if (pathComplete) {
                val = crtObj;
            }
        }

        return val;
    };

    this.isEntry = function (object) {
        for (var r in object) {
            return !!r;
        }
        return false;
    };

    this.searchInEnumFromValue = function (value, enumArray) {
        if (!value || !enumArray) {
            return null;
        }
        for (var i = 0; i < enumArray.length; i++) {
            if (enumArray[i] && enumArray[i].value === value) {
                return enumArray[i];
            }
        }
        return null;
    };

    this.searchIndex = function (list, value, path) {
        for (var i = 0; i < list.length; i++) {
            if (self.readPath(list[i], path) === value) {
                return i;
            }
        }
        return -1;
    };

    this.isNonEmptyArrayInPath = function (object, path) {
        var obj = self.readPath(object, path);
        return !!(obj && obj.length && obj.length > 0);
    };

    this.isNonEmptyObject = function (object) {
        if (!object) {
            return false;
        }
        for (var key in object) {
            return !!key;
        }
        return false;
    };

    this.searchParameterParents = function (object, parameter) {
        for (var key in object) {
            if (key === parameter) {
                return object;
            }
            if ((typeof object[key]).toUpperCase() === 'OBJECT' && object[key] && !object[key].length) {
                var val = self.searchParameterParents(object[key], parameter);
                if (val) {
                    return val;
                }
            }
        }
        return null;
    };

}]);

core.service('FileManager', function ($translate, ModalService) {
    return {
        downloadFile: function (link) {
            var emergencyDownload = function () {
                ModalService.downloadPopup({
                    validateBtn: $translate.instant('common.button.download'),
                    cancelBtn: $translate.instant('common.button.cancel'),
                    validateBtnCls: 'btn-primary',
                    cancelBtnCls: 'btn-default',
                    modalText: $translate.instant('common.download.confirmation'),
                    link: link
                });
            };
//				if (GLOBALVARS.browser.type === 'ie' || GLOBALVARS.browser.mobile === true) {
//					emergencyDownload();
//					return;
//				}
            try {
                var downloadAtt = document.createAttribute('download');
                var save = document.createElement('a');
                save.href = link;
                save.target = '_blank';
                save.setAttributeNode(downloadAtt);
                var evt = document.createEvent('MouseEvents');
                evt.initMouseEvent('click', true, true,
                    window, 1, 0, 0, 0, 0,
                    false, false, false, false, 0, null);

                save.dispatchEvent(evt);
            } catch (e) {
                emergencyDownload();
            }

        }
    };
});

core.service('ObjectFilter', ['ObjectUtils', '$filter', function (ObjectUtils, $filter) {
    this.sortArray = function (array, keys) {
        array.sort(function (a, b) {
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];

                var sort = key;
                if (!sort.column) {
                    var dir = true;
                    if (key.charAt(0) === '-') {
                        dir = false;
                        key = key.substring(1);
                    }

                    sort = {
                        column: key,
                        dir: dir
                    };
                }

                var m = 1;
                if (sort.dir === true) {
                    m = -1;
                }
                var av = ObjectUtils.readPathSafe(a, sort.column, '');
                var bv = ObjectUtils.readPathSafe(b, sort.column, '');
                if (av > bv) {
                    return 1 * m;
                } else if (av < bv) {
                    return -1 * m;
                }
            }
            return 0;
        });
        return array;
    };

    this.sortFilterArray = function (array, keys) {
        var sorted = array;
        for (var i = 0; i < keys.length; i++) {
            sorted = $filter('orderBy')(sorted, keys[i].column, keys[i].dir);
        }
        return sorted;
    };
}]);


core.service('StlDateUtils', [function () {
    var self = this;
    /**
     * Check if a date (date) is in an interval
     * @param {Interva} interval ({begin, end})
     * @param {type} date the date to test
     * @returns {boolean} true when date in interval
     */

    this.isInInterval = function (interval, date) {
        return interval.begin.getTime() <= date.getTime() && interval.end.getTime() >= date.getTime();
    };

    this.convertToHumanDate = function (date) {
        return moment(date).format('DD.MM.YYYY');
    };

    this.convertToHumainDateWithSecs = function (date) {
        return moment(date).format('DD.MM.YYYY HH:mm:ss');
    };

    this.convertToBusinessDate = function (date) {
        return moment(date).format('YYYY-MM-DD');
    };
    this.convertFromBusinessDate = function (date) {
        return moment(date, 'YYYY-MM-DD').toDate();
    };

    this.convertFromBusinessDateGlobal = function (date) {
        return moment(date).toDate();
    };

    this.getMaxDate = function () {
        return moment('9999-01-01', 'YYYY-MM-DD').toDate();
    };

    this.getMaxBusinessDate = function () {
        return this.convertToBusinessDate(this.getMaxDate());
    };

    this.getMinDate = function () {
        return moment('1900-01-01', 'YYYY-MM-DD').toDate();
    };

    this.getMinBusinessDate = function () {
        return this.convertToBusinessDate(this.getMinDate());
    };

    this.addDays = function (date, days) {
        return moment(date).add(days, 'days').toDate();
    };

    this.isBusinessMaxDate = function (bDate) {
        var date = this.convertFromBusinessDate(bDate);
        if (date) {
            return date.getFullYear() >= 9999;
        } else {
            return false;
        }
    };

    this.createInterval = function (start, end) {
        return {
            start: start,
            end: end
        };
    };

    /**
     *
     * @param {type} interval {start (Date or YYYY-MM-DD), end (Date or YYYY-MM-DD)} (inclusibve)
     * @param {type} date the date to test
     * @returns {boolean} true if the date is in the interval
     */
    this.isInInterval = function (interval, date) {
        try {
            var is = interval.start;
            var ie = interval.end;

            var start, end;
            if (is instanceof Date) {
                start = interval.start.getTime();
            } else {
                start = moment(interval.start, 'YYYY-MM-DD').toDate().getTime();
            }
            if (ie instanceof Date) {
                end = interval.end.getTime();
            } else {
                end = moment(interval.end, 'YYYY-MM-DD').toDate().getTime();
            }
            var test = date.getTime();
            return start <= test && end >= test;
        } catch (e) {
            return false;
        }
    };

    this.getCorrectDateForInterval = function (businessDate, from, to) {
        var date = self.convertFromBusinessDate(businessDate);
        date.setFullYear(from.getFullYear());
        if (from.getTime() > date.getTime()) {
            date.setFullYear(to.getFullYear());
        }
        return date;
    };
}]);

core.service('ConnectionUtils', ['$http', '$q', function ($http, $q) {
    this.checkAuthenticated = function (checkUrl) {
        var deferred = $q.defer();
        $http({
            method: 'get',
            url: checkUrl
        }).then(function (data) {
            try {
                if (!data.data.connected) {
                    deferred.reject(data);
                    return;
                }
            } catch (e) {
                deferred.reject(data);
                return;
            }
            deferred.resolve();
        }, function (data) {
            deferred.reject(data);
        });
        return deferred.promise;
    };
}]);

core.service('StringUtil', [function () {
    this.regexGlobalMatch = function (value, regex) {
        var ar = value.match(new RegExp(regex, 'g'));
        for (var i = 0; ar && i < ar.length; i++) {
            if (ar[i] === value) {
                return true;
            }
        }
        return false;
    };

    this.toTitleCase = function (str) {
        return str.replace(/(?:^|\s)\w/g, function (match) {
            return match.toUpperCase();
        });
    };
}]);

core.service('PrintUtil', [function () {
    this.printDiv = function (divId, frameWidth, frameHeight) {
        var printContents = document.getElementById(divId).innerHTML;

        var linkTags = document.getElementsByTagName('link');
        var stylesheets = '';
        angular.forEach(linkTags, function(value, key) {
            stylesheets += '<link rel="stylesheet" type="text/css" href="'+ value.href +'" />';
        });

        var popupWin = window.open('', '_blank', 'width=' + frameWidth + ',height=' + frameHeight);
        popupWin.document.open();
        popupWin.document.write('<html><head>' + stylesheets + '</head><body onload="window.print()" onfocus="setTimeout(function () { window.close(); }, 500);">' + printContents + '</body></html>');
        popupWin.document.close();
    };
}]);

core.service('ErrorUtil', ['$log', '$translate', 'StringUtil', function ($log, $translate) {
    this.translateError = function (error, defaultKey, prefix) {
        var translatedErrorMsg = $translate.instant(defaultKey);
        var msgPrefix = prefix ? prefix : '';
        var translation = $translate.instant(msgPrefix + error.data.message);
        if (translation && translation.indexOf(error.data.message) < 0) {
            translatedErrorMsg = translation;
        }
        return translatedErrorMsg;
    };

    this.treatError = function(error, frontend, frontendLogFn) {
        $log.error(error);

        if (frontend) {
            frontendLogFn.apply(this);
        }
    };

}]);

core.service('ValidationUtil', ['$translate', 'StringUtil', function ($translate, StringUtil) {
    this.getValidationMessage = function (validationDtos, indexableItems, fields) {
        var msg = null;
        angular.forEach(fields, function (value) {
            var validationDto = validationDtos[indexableItems.index + value];
            if (!angular.isUndefined(validationDto) && validationDto !== null) {
                if (msg == null) {
                    msg = '';
                } else {
                    msg += '<br/><br/>';
                }
                msg += '<b>' + $translate.instant(StringUtil.toTitleCase(validationDto.field)) + ' :</b> ' + $translate.instant(validationDto.message);
            }
        });
        return msg;
    };
}]);
